import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import UploadDocIcon from '../assets/imgs/upload-documents-icon.svg'
import VerifyYourNumberModal from './VerifyYourNumberModal'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const WorkLicenseModal = ({ handleWorkLicenseModal, modalOpen = false }) => {
  const [
    toggleVerifyYourNumberModal,
    setToggleVerifyYourNumberModal,
  ] = React.useState(false)

  const handleVerifyYourNumberModal = () => {
    if (modalOpen) {
      handleWorkLicenseModal(false)
    }
    setToggleVerifyYourNumberModal(!toggleVerifyYourNumberModal)
  }
  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={() => handleWorkLicenseModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div>
            <h3 className="fs-24 mb-3 fw-bold">Work License</h3>
            <div className="upload-documents-wrapper py-5 mb-5">
              <img src={UploadDocIcon} alt="Upload Icon" className="mb-3" />
              <p className="fs-15 font-weight-bold color-primary">
                Upload Work License Documents
              </p>
            </div>
            <div>
              <Button
                disableElevation
                fullWidth
                id="btn-transparent"
                className="pointer mt-5"
              >
                Skip
              </Button>
              <Button
                disableElevation
                id="btn-primary-no-shadow"
                variant="contained"
                className="pointer mt-3"
                fullWidth={true}
                onClick={handleVerifyYourNumberModal}
              >
                Next
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* {toggleVerifyYourNumberModal && ( */}
        <VerifyYourNumberModal
          handleVerifyYourNumberModal={handleVerifyYourNumberModal}
          modalOpen={toggleVerifyYourNumberModal}
        />
      {/* )} */}
    </div>
  )
}

export default WorkLicenseModal
